// extracted by mini-css-extract-plugin
export default {"SmallMargin":"Utils_SmallMargin__LfKEM","SmallMarginSide":"Utils_SmallMarginSide__d4Shr","Width":"Utils_Width__dTm6d","RightMargin":"Utils_RightMargin__JG4ga"};